<template>
    <div>
        <!-- The page body is architecture.org in an iframe, so this document had
             no heading of its own. Visually hidden: the framed page shows its
             own title. -->
        <h1 class="sr-only">About the Chicago Architecture Center</h1>
        <UtilitiesWebView url="/about" />
    </div>
</template>
